<template>
  <div class="signFor">
    <el-dialog
      title="操作记录"
      :visible.sync="taskLogVisible"
      width="40%"
      :before-close="handleClose">
      <el-table
        :data="taskLogList"
        style="width: 100%">
          <el-table-column type="index"
                           label="序号"
                           width="50">
          </el-table-column>
          <el-table-column prop="ytlOptContent"
                           label="操作内容"
                           min-width="120">
          </el-table-column>
          <el-table-column prop="ytlOptName"
                           label="操作人"
                           min-width="120">
          </el-table-column>
          <el-table-column prop="ytlOptDate"
                           label="操作时间"
                           min-width="120">
          </el-table-column>

      </el-table>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ['taskLogVisible', 'taskLogList'],
  data () {
    return {

    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDialog', false)
    },
    submit () {

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/assignmentManage/components/taskLog.vue